import { Collection, } from "@bluelibs/x-ui";
import { BankAccount } from "@root/api.types";
import { CompaniesCollection, BanksCollection, UsersCollection, } from "@bundles/UIAppBundle/collections";
export class BankAccountsCollection extends Collection {
    getName() {
        return "BankAccounts";
    }
    getInputs() {
        return {
            insert: "BankAccountInsertInput!",
            update: "BankAccountUpdateInput!",
        };
    }
    // Return here the relations with other configs
    getLinks() {
        return [
            {
                collection: () => CompaniesCollection,
                name: "company",
                field: "companyId",
            },
            {
                collection: () => BanksCollection,
                name: "bank",
                field: "bankId",
            },
            {
                collection: () => UsersCollection,
                name: "createdBy",
                field: "createdById",
            },
            {
                collection: () => UsersCollection,
                name: "updatedBy",
                field: "updatedById",
            },
        ];
    }
    // Return here how you want to transform certain fields
    getTransformMap() {
        return {
            createdAt: (v) => (v && new Date(v) ? new Date(v) : v),
            updatedAt: (v) => (v && new Date(v) ? new Date(v) : v),
        };
    }
}
